class ProductMediaGallery extends HTMLElement {
  connectedCallback() {
    this.mediaItems = this.querySelectorAll('[data-media-item]');
    this.thumbnails = this.querySelectorAll('[data-thumbnail]');

    this.querySelectorAll('[data-main-img]').forEach((img) => {
      if (!img.dataset.src) this.bindImageFade(img);
    });

    this.thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', () => this.select(thumb.dataset.mediaId));
    });

    document.addEventListener('variant:change', (e) => {
      const variant = e.detail?.variant;
      if (!variant) return;
      const mediaId = variant.featured_media?.id;
      if (mediaId) {
        this.select(String(mediaId));
        return;
      }
      const imageId = variant.featured_image?.id;
      if (imageId) this.selectByImageId(String(imageId));
    });

    const active = this.querySelector('[data-thumbnail][aria-pressed="true"]');
    if (active) {
      const scroller = active.closest('ul, [data-thumbnails]') || active.parentElement;
      if (scroller) {
        const thumbRect = active.getBoundingClientRect();
        const scrollRect = scroller.getBoundingClientRect();
        if (thumbRect.left < scrollRect.left || thumbRect.right > scrollRect.right) {
          this.scrollThumbnailIntoView(active, { instant: true });
        }
      }
    }
  }

  bindImageFade(img) {
    const blur = img.closest('[data-media-item]')?.querySelector('[data-blur]');
    const apply = (instant) => {
      if (instant) {
        img.classList.remove('transition-opacity');
        blur?.classList.remove('transition-opacity');
      }
      img.classList.remove('opacity-0');
      img.classList.add('opacity-100');
      if (blur) {
        blur.classList.remove('opacity-100');
        blur.classList.add('opacity-0');
      }
    };
    if (img.complete && img.naturalWidth > 0) {
      apply(true);
    } else {
      img.addEventListener('load', () => apply(false), { once: true });
      img.addEventListener('error', () => apply(false), { once: true });
    }
  }

  loadImage(item) {
    const img = item.querySelector('[data-main-img]');
    if (!img || !img.dataset.src) return;
    if (img.dataset.srcset) {
      img.srcset = img.dataset.srcset;
      delete img.dataset.srcset;
    }
    img.src = img.dataset.src;
    delete img.dataset.src;
    this.bindImageFade(img);
  }

  selectByImageId(imageId) {
    for (const item of this.mediaItems) {
      if (item.dataset.imageId === imageId) {
        this.select(item.dataset.mediaId);
        return;
      }
    }
  }

  scrollThumbnailIntoView(thumb, { instant = false } = {}) {
    const scroller = thumb.closest('ul, [data-thumbnails]') || thumb.parentElement;
    if (!scroller) return;
    const thumbCenter = thumb.offsetLeft + thumb.offsetWidth / 2;
    const target = thumbCenter - scroller.clientWidth / 2;
    const max = scroller.scrollWidth - scroller.clientWidth;
    const left = Math.max(0, Math.min(target, max));
    if (instant) {
      scroller.scrollLeft = left;
    } else {
      scroller.scrollTo({ left, behavior: 'smooth' });
    }
  }

  select(mediaId) {
    this.mediaItems.forEach((item) => {
      const match = item.dataset.mediaId === mediaId;
      item.classList.toggle('opacity-100', match);
      item.classList.toggle('opacity-0', !match);
      item.classList.toggle('pointer-events-none', !match);
      if (match) {
        this.loadImage(item);
      } else {
        const video = item.querySelector('video');
        if (video) video.pause();
      }
    });
    this.thumbnails.forEach((thumb) => {
      const match = thumb.dataset.mediaId === mediaId;
      thumb.setAttribute('aria-pressed', String(match));
      thumb.classList.toggle('border-[#3b4041]', match);
      thumb.classList.toggle('border-[#e5e5e5]', !match);
      thumb.classList.toggle('hover:border-[#a3a3a3]', !match);
      if (match) this.scrollThumbnailIntoView(thumb);
    });
  }
}

customElements.define('product-media-gallery', ProductMediaGallery);
